import { html } from "lit";
var icon_tags_default = () => html`
  <svg stroke-fill viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(3 3)" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
      <path
        d="M0 1.78v7.44c0 .94.38 1.85 1.04 2.52l13.74 13.74c.7.7 1.83.7 2.52 0l8.18-8.18c.7-.7.7-1.82 0-2.52L11.74 1.04A3.57 3.57 0 0 0 9.22 0H1.78C.8 0 0 .8 0 1.78Z"
        stroke-width="1.75" />
      <circle cx="6.24" cy="6.24" r="1.78" />
    </g>
  </svg>
`;
export {
  icon_tags_default as default
};
//# sourceMappingURL=icon-tags.js.map
